import { GAME_RESET_GOTO_MENU } from "../../../gameStateEventTrigger.js";
import { ASSET_MANAGER } from "../../main.js";
import { ButtonEntity } from "../buttonEntity.js";
import { WinScreenRender } from "./winScreenRender.js";
export class WinScreenScene {
    constructor(sceneTrigger, inputSystem, canvasWidth, canvasHeight) {
        this.sceneTrigger = sceneTrigger;
        this.inputSystem = inputSystem;
        this.canvasWidth = canvasWidth;
        this.canvasHeight = canvasHeight;
    }
    onEnter(sceneManager) {
        // Return to main menu
        const handleMainMenuClick = () => {
            ASSET_MANAGER.stopAllMusic();
            this.sceneTrigger.assertChange(null, GAME_RESET_GOTO_MENU);
        };
        const mainMenuButton = new ButtonEntity("Return to Menu", "transparent", "white", (this.canvasWidth) / 2 - 150, (this.canvasHeight) - 200, 300, 50, this.inputSystem, handleMainMenuClick, "center");
        setTimeout(() => {
            sceneManager.addTransientUIEntity(mainMenuButton);
        }, 2500);
        const screenRenderer = new WinScreenRender();
        sceneManager.addEntity(screenRenderer);
    }
    onResume(sceneManager) {
    }
    onExit() {
        // Nothing for now, end the game
    }
    update(context) { }
    draw(context) { }
}
